// src/services/TeamService.ts
import { ITeamMember, CreateTeamMemberDto } from '../types/Team';
import { apiClient } from './apiClient'; 

// Obtener todos los miembros del equipo
export const getTeamMembers = async (): Promise<ITeamMember[]> => {
  try {
    return await apiClient('team', { method: 'GET' });
  } catch (error) {
    console.error("Error al obtener miembros del equipo:", error);
    throw error;
  }
};

// Obtener miembro por ID
export const getTeamMemberById = async (id: number): Promise<ITeamMember> => {
  try {
    return await apiClient(`team/${id}`, { method: 'GET' });
  } catch (error) {
    console.error("Error al obtener miembro por ID:", error);
    throw error;
  }
};

// Crear nuevo miembro
export const createTeamMember = async (teamMemberData: CreateTeamMemberDto): Promise<ITeamMember> => {
  try {
    return await apiClient('team', {
      method: 'POST',
      body: JSON.stringify(teamMemberData),
    });
  } catch (error) {
    console.error("Error al crear miembro:", error);
    throw error;
  }
};

// Actualizar miembro
export const updateTeamMember = async (teamMemberData: ITeamMember): Promise<ITeamMember> => {
  try {
    const { id, ...updateData } = teamMemberData as any;
    delete updateData.deletedAt;

    return await apiClient(`team/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(updateData),
    });
  } catch (error) {
    console.error("Error al actualizar miembro:", error);
    throw error;
  }
};

// Eliminar miembro (soft delete)
export const deleteTeamMember = async (id: number): Promise<boolean> => {
  try {
    await apiClient(`team/${id}`, { method: 'DELETE' });
    return true;
  } catch (error) {
    console.error("Error al eliminar miembro:", error);
    return false;
  }
};

// Obtener miembros destacados
export const getFeaturedTeamMembers = async (): Promise<ITeamMember[]> => {
  try {
    return await apiClient('team/featured', { method: 'GET' });
  } catch (error) {
    console.error("Error al obtener miembros destacados:", error);
    throw error;
  }
};

// Alternar estado activo
export const toggleTeamMemberActive = async (id: number, isActive: boolean): Promise<ITeamMember> => {
  try {
    return await apiClient(`team/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ isActive }),
    });
  } catch (error) {
    console.error("Error al cambiar estado activo:", error);
    throw error;
  }
};

// Alternar estado destacado
export const toggleTeamMemberFeatured = async (id: number, isFeatured: boolean): Promise<ITeamMember> => {
  try {
    return await apiClient(`team/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ isFeatured }),
    });
  } catch (error) {
    console.error("Error al cambiar estado destacado:", error);
    throw error;
  }
};